// utils/storage.js

const PROFILE_KEY = "guest_profile";
const CONVERSION_KEY = "guest_conversion_state";

export const isValidProfile = (profile) => {
  if (!profile || typeof profile !== "object") return false;

  const hasCommitment =
    Boolean(profile.commitment_pref) || profile.commitment_flexible === true;

  return Boolean(
    profile.guest_id &&
      Number.isFinite(Number(profile.age)) &&
      Number(profile.age) > 0 &&
      Array.isArray(profile.favorite_genres) &&
      profile.favorite_genres.length > 0 &&
      Array.isArray(profile.favorite_moods) &&
      profile.favorite_moods.length > 0 &&
      hasCommitment &&
      profile.vibe_pref
  );
};

export const saveProfile = (profile) => {
  if (!isValidProfile(profile)) {
    console.warn("⚠️ Attempted to save invalid profile:", profile);
    return;
  }

  try {
    sessionStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  } catch (err) {
    console.error("❌ Failed to save profile:", err);
  }
};

export const loadProfile = () => {
  const raw = sessionStorage.getItem(PROFILE_KEY);

  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);

    if (!isValidProfile(parsed)) {
      console.warn("⚠️ Stored profile is invalid:", parsed);
      return null;
    }

    return parsed;
  } catch (err) {
    console.error("⚠️ Failed to parse stored profile:", err);
    return null;
  }
};

export const clearProfile = () => {
  try {
    sessionStorage.removeItem(PROFILE_KEY);
  } catch (err) {
    console.error("❌ Failed to clear profile:", err);
  }
};

export const saveGuestConversionState = ({ profile, results = [] }) => {
  if (!isValidProfile(profile) || !Array.isArray(results)) {
    console.warn("⚠️ Attempted to save invalid guest conversion state.");
    return false;
  }

  try {
    sessionStorage.setItem(
      CONVERSION_KEY,
      JSON.stringify({
        profile,
        results: results.map((result) => ({
          show_id: result.show_id ?? result.id ?? null,
          title: result.title ?? null,
        })),
      })
    );
    return true;
  } catch (err) {
    console.error("❌ Failed to save guest conversion state:", err);
    return false;
  }
};

export const loadGuestConversionState = () => {
  const raw = sessionStorage.getItem(CONVERSION_KEY);

  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    const profile = parsed?.profile;
    const results = Array.isArray(parsed?.results) ? parsed.results : [];

    if (!isValidProfile(profile)) {
      console.warn("⚠️ Stored guest conversion state is invalid.");
      return null;
    }

    return { profile, results };
  } catch (err) {
    console.error("⚠️ Failed to parse guest conversion state:", err);
    return null;
  }
};

export const clearGuestConversionState = () => {
  try {
    sessionStorage.removeItem(CONVERSION_KEY);
  } catch (err) {
    console.error("❌ Failed to clear guest conversion state:", err);
  }
};
